module.exports = __webpack_public_path__ + "static/media/icon_commercial.3ecb352b.svg";